import { compose } from 'recompose'
import withFilteredHoverHandlers from 'components/common/hoc/withFilteredHoverHandlers'
import withHeaderHorizontalNav from 'components/common/hoc/withHeaderHorizontalNav'
import ChooseStore from './ChooseStore'

export default compose(
  withFilteredHoverHandlers,
  withHeaderHorizontalNav
)(ChooseStore)
